import { indicatorMeta } from '@/app/lib/quant/indicatorName'
import type { ManualIndicator } from '@/app/lib/quant/quantApi'
import type { IndicatorType } from '@/app/lib/quant/types'
import { QuantIndicatorRow } from '@/ui/QuantIndicatorRow'

export interface QuantIndicatorsRailProps {
  indicators: ManualIndicator[]
  /** Catalog types for the row meta label; absent until loaded (the row falls back to the type). */
  catalog: IndicatorType[]
  onToggle: (id: string) => void
  onEdit: (id: string) => void
  onAdd: () => void
}

/**
 * The Indicators rail body (spec 036, handoff 4.4): the scrolling list of rows
 * and the `+ Add indicator` footer. The header lives in `QuantRail`.
 */
export function QuantIndicatorsRail({ indicators, catalog, onToggle, onEdit, onAdd }: QuantIndicatorsRailProps) {
  return (
    <>
      <div className="min-h-0 flex-1 overflow-y-auto py-2">
        {indicators.map((ind) => (
          <QuantIndicatorRow
            key={ind.id}
            name={ind.name}
            meta={indicatorMeta(
              catalog.find((c) => c.type === ind.type),
              ind.type,
              ind.params,
            )}
            color={ind.color}
            on={ind.on}
            onToggle={() => onToggle(ind.id)}
            onEdit={() => onEdit(ind.id)}
          />
        ))}
      </div>
      <div className="flex shrink-0 flex-col gap-2 border-t border-ink-20 px-4 pt-3 pb-4">
        <button
          type="button"
          onClick={onAdd}
          className="cursor-pointer border-0 bg-ink px-3 py-2.5 font-sans text-[10.5px] font-bold tracking-[0.22em] text-paper uppercase"
        >
          + Add indicator
        </button>
        <span className="font-mono text-[10.5px] leading-[1.5] text-ink-50">
          Click a row to edit its settings. The backend recomputes and streams the result.
        </span>
      </div>
    </>
  )
}
